import styled from 'styled-components'

const BurgerMenu = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ theme }) => theme.body};
  height: 100vh;
  text-align: left;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 6;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  display: ${({ open }) => (open ? 'flex' : 'none')};
  transition: transform 0.3s ease-in-out;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 100%;
    font-size: 3rem;
  }
  ul{
    display: grid;
    >li{
        font-size: 2rem;
    text-transform: uppercase;
    text-align: center;
    padding: 2rem 0;
    letter-spacing: 0.1rem;
    color: ${({ theme }) => theme.text};
    text-decoration: none;
    transition: color 0.3s linear;
    
    @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: .4rem;
    font-size: .9rem;
    }

    &:hover {
      color: ${({ theme }) => theme.hover};
    }
  }
  
  a {
    font-size: 2rem;
    text-transform: uppercase;
    text-align: center;
    padding: 2rem 0;
    letter-spacing: 0.1rem;
    color: ${({ theme }) => theme.text};
    text-decoration: none;
    transition: color 0.3s linear;
    
    @media (max-width: ${({ theme }) => theme.mobile}) {
    padding: .4rem;
    font-size: .9rem;
  }

    &:hover {
      color: ${({ theme }) => theme.hover};
    }
  }
  }
`
export default BurgerMenu;